import request from './request';

export function getWechatShareConfig(params) {
  return request.get('/ajax/wechatShare', { params });
}

export function getAjaxList(params) {
  return request.get('/ajax/list', { params });
}
